import { isEmpty } from 'lodash'
import { success } from '@/utils/alert'

export default {
  prepareSave (speciality) {
    if (isEmpty(speciality.attachment.content)) {
      delete speciality.attachment
    }

    return speciality
  },
  afterUpdated () {
    success('Especialidade Médica atualizada com sucesso.')
  },
  afterCreated () {
    success('Especialidade Médica incluida com sucesso.')
  },
  redirectToProfessionalRecordSpecialities () {
    return this.$router.push({name: 'professional.record.specialities.index'})
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/form/resources/methods.js